export default "/_next/static/images/wag-logo-69f61d3bf6aba604f1d9e06cb017c360.svg";